import React, { useRef } from "react";
import { RCCDropDownItem, RCCGrid, RCCIcon } from "react-common-components";
import CheckPermission from "src/components/CheckPermission";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { AuditSituation, IListOfAudits } from "../interface";
import CardAudits from "./cardAudits";
import ListAudits from "./listAudits";
import ModalAudit from "./ModalAudit";
import { IRefModalAuditAddOrChange } from "./ModalAudit/interface";
import ModalRunAudit from "./ModalRunAudit";
import { IRefModalRunAudit } from "./ModalRunAudit/interface";

const ListOfAudits: React.FC<IListOfAudits> = ({
	layoutList, 
	data,
	filterListSituation,
	filterListType,
	onCallbackDelete,
	onCallbackUpdate,
	loadGroupers
}) => {
	const {translate} = useTranslation();
	const refModalAudit = useRef<IRefModalAuditAddOrChange>(null);
	const refModalRunAudit = useRef<IRefModalRunAudit>(null);

	const options = (row: any) => (	
		<RCCGrid 
			container
			item
			styleInline="justify-content: flex-end;"
		>
			<OptionsColumn>
				{
					row.adb001Situacao !== AuditSituation.FINISHED && row.adtbb004.length > 0 &&
					<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
						<RCCDropDownItem 
							selfEnclose
							onClick={() => {refModalRunAudit.current?.openModal(row.adb001Id, row.fullTitle);}}
						>
							<RCCIcon name="play"
							/>
							{translate("Executar Auditoria")}
						</RCCDropDownItem>												
					</CheckPermission>	
				}
				{row.adb001Situacao === AuditSituation.FINISHED ? (
					<RCCDropDownItem
						selfEnclose
						onClick={() => {refModalAudit.current?.actionButtonChange(row.adb001Id, false);}}
					>
						<RCCIcon name="eye"/>
						{translate("Visualizar")}
					</RCCDropDownItem>
				) : (
					<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
						<RCCDropDownItem
							selfEnclose
							onClick={() => {refModalAudit.current?.actionButtonChange(row.adb001Id, false);}}
						>
							<RCCIcon name="pencil"/>
				  	{translate("Alterar")}
						</RCCDropDownItem>											
					</CheckPermission>
				)}
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
					<RCCDropDownItem 
						selfEnclose
						onClick={() => { refModalAudit.current?.actionButtonChange(row.adb001Id, true); }}
					>
						<RCCIcon name="copy" 
						/>
						{translate("Copiar")}
					</RCCDropDownItem>													
				</CheckPermission>
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
					<RCCDropDownItem 
						selfEnclose
						onClick={() => { refModalAudit.current?.actionButtonDelete(row); }}
					>
						<RCCIcon name="trash" 
						/>
						{translate("Excluir")}
					</RCCDropDownItem>															
				</CheckPermission>
			</OptionsColumn>
		</RCCGrid>
	);

	const FilterSituationAndType = (audit: any) => audit.adb001Situacao === filterListSituation && audit.adb001Tipo === filterListType;
	const FilerSituation = (audit: any) => audit.adb001Situacao === filterListSituation;
	const FilterType = (audit: any) => audit.adb001Tipo === filterListType;

	const FilterOption = () => {
		if(filterListSituation && filterListType)
			return FilterSituationAndType;

		if(filterListSituation)
			return FilerSituation;

		if(filterListType)
			return FilterType;

		return undefined;
	};

	return (
		<>

			{layoutList === "card" ? (
				<CardAudits
					data={data}
					options={options}
					filter={FilterOption()}	
				/>
			): (
				<ListAudits
					data={data}
					options={options}
					filter={FilterOption()}
				/>
			)}

			<ModalAudit ref={refModalAudit} loadGroupers={loadGroupers} onCallbackDelete={onCallbackDelete} onCallbackUpdate={onCallbackUpdate} />
			<ModalRunAudit ref={refModalRunAudit} onCallbackUpdate={onCallbackUpdate} />
		</>
	);
};

export default ListOfAudits;
